module.exports = __webpack_public_path__ + "static/mail-bb18bdbbef437b2d50518db5a8292c94.png";